import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { MdPerson, MdSwapHoriz, MdToll } from "react-icons/md";
import Skewer from "@Components/Decor/Skewer";
import IconHolder from "@Components/Decor/IconHolder";
import Float from "@Components/Decor/Float";
import TransferCard from "../TransferCard/TransferCard";

const LightIconHolder: FC<{ icon: ReactNode }> = ({ icon }) => (
  <div className="bg-background-default text-icon-active outline-background-primary-lighter flex w-min items-center rounded-full shadow-sm outline-4 outline">
    {icon}
  </div>
);

function PointsExchangeIllustration() {
  const { t } = useTranslation();

  return (
    <div
      className="points-exchange-hero-decor-scroll pointer-events-none absolute end-0 top-6 h-20 w-28 shrink-0 lg:relative lg:end-auto lg:top-auto lg:h-64 lg:w-96"
      aria-hidden
    >
      <div className="scale-30 absolute end-0 top-0 h-64 w-96 origin-top-right lg:scale-100 rtl:origin-top-left">
        <Skewer angle={4} className="absolute end-10 top-2 bg-transparent! p-0! not-italic">
          <Float duration={5} delay={-1}>
            <TransferCard
              title={t("PointsExchange.listing.hero.cardTitle")}
              subtitle={t("PointsExchange.listing.hero.cardSubtitle")}
              sender={t("PointsExchange.listing.hero.you")}
              amountLabel={t("PointsExchange.listing.hero.amount")}
              amount="500"
              unit={t("PointsExchange.listing.hero.pointsShort")}
              status={t("PointsExchange.listing.hero.sent")}
            />
          </Float>
        </Skewer>

        <div className="absolute start-6 top-8">
          <Float duration={4} delay={-1.2} distance={-6}>
            <LightIconHolder icon={<MdToll className="aspect-square h-auto w-10 p-2" />} />
          </Float>
        </div>
        <div className="absolute end-6 top-4">
          <Float duration={4.5} delay={-3} distance={-6}>
            <LightIconHolder icon={<MdPerson className="aspect-square h-auto w-8 p-2" />} />
          </Float>
        </div>
        <div className="absolute end-4 top-48">
          <Float duration={3.5} delay={-0.6} distance={-6}>
            <IconHolder icon={<MdSwapHoriz className="aspect-square h-auto w-10 p-2" />} />
          </Float>
        </div>
      </div>
    </div>
  );
}

export default function PointsExchangeHero() {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full items-center justify-between gap-8">
      <div className="z-10 flex flex-col gap-4 pe-32 lg:pe-0">
        <h1 className="font-poppins text-font-default text-4xl font-semibold md:text-5xl">{t("PointsExchange.listing.hero.title")}</h1>
        <p className="text-font-subtle text-sm leading-loose md:text-base">
          {t("PointsExchange.listing.hero.subtitle")}{" "}
          <Skewer angle={3} className="px-2 py-1 font-bold!">
            {t("PointsExchange.listing.hero.highlight")}
          </Skewer>
        </p>
      </div>
      <PointsExchangeIllustration />
    </div>
  );
}
